import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { getWebPageVariant, WebPageType } from '../../../constants/webPageType';

import styles from './EmailPhoneTabBar.module.css';

export type EmailPhoneTabBarProps = {
  activeTab: 'email' | 'phone';
  webPageType: WebPageType;
  onSelectTab: (tab: 'email' | 'phone') => void;
};

export const EmailPhoneTabBar = memo(
  ({ activeTab, onSelectTab, webPageType }: EmailPhoneTabBarProps) => {
    const { t } = useTranslation();

    return (
      <div className={styles.tabBar}>
        <button
          className={
            activeTab === 'email'
              ? `${styles.tab} ${
                  styles[getWebPageVariant(webPageType).classVariantLight1]
                }`
              : styles.tab
          }
          onClick={() => onSelectTab('email')}
        >
          {t('Email / Username')}
        </button>
        <button
          className={
            activeTab === 'phone'
              ? `${styles.tab} ${
                  styles[getWebPageVariant(webPageType).classVariantLight1]
                }`
              : styles.tab
          }
          onClick={() => onSelectTab('phone')}
        >
          {t('Phone Number')}
        </button>
      </div>
    );
  },
);
